<template>
  <div style="height:100vh;display:flex;flex-direction:column;">
    <div v-if="listLoading" class="stock-list-loading"><van-loading size="28px" vertical>加载中...</van-loading></div>
    <div style="position:fixed;top:0;left:0;right:0;background:#F7F8FA;height:56px;border-bottom:1px solid #EBEDF0;z-index:999;display:flex;align-items:center;padding:0 12px;">
      <!-- 返回按钮 -->
      <div @click="onClickLeft" style="width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">
        <van-icon name="arrow-left" size="20" color="#333333" style="font-weight:600;" />
      </div>

      <!-- 搜索框 -->
      <div style="flex:1;margin:0 12px;">
        <div style="background:#FFFFFF;border-radius:15px;border:1px solid #E5E5E5;height:30px;display:flex;align-items:center;padding:0 12px;">
          <van-icon name="search" size="14" color="#999999" style="margin-right:6px;" />
          <input
              v-model="v_search"
              placeholder="搜索盘点单号/盘点人"
              style="border:none;outline:none;background:transparent;flex:1;font-size:13px;color:#333333;height:100%;"
          />
        </div>
      </div>

      <!-- 右侧按钮组 -->
      <div style="display:flex;gap:8px;align-items:center;flex-shrink:0;">
        <div @click="onSearch" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
          <van-icon name="search" size="14" color="#1ECD84" />
        </div>
        <div @click="onAdd" :class="addBool?'icon-disabled':''" style="width:30px;height:30px;background:#FFFFFF;border-radius:6px;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,0.08);">
          <van-icon name="plus" size="14" :color="addBool?'#AAAAAA':'#235EFF'" />
        </div>
      </div>
    </div>
    <div style="flex:1;overflow-y:auto;background:#F7F8FA;margin-top:56px;padding-bottom:20px;">
      <div style="padding: 12px;">
        <div v-for="(item,index) in tabData" :key="index" class="check-card">
          <!-- 卡片头部 -->
          <div class="card-header">
            <div class="card-title">盘点单号：{{item.IDNO}}</div>
            <div class="card-status" :class="item.STFG === 'Y' ? 'status-success' : 'status-pending'">
              {{item.STFG === 'Y' ? '已审核' : '未审核'}}
            </div>
          </div>

          <!-- 卡片内容 -->
          <div class="card-content">
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">盘点仓库</span>
                <span class="info-value">{{item.STKNM}}</span>
              </div>
              <div class="info-row">
                <span class="info-label">盘点类别</span>
                <span class="info-value">{{item.OTHTYNM}}</span>
              </div>
            </div>
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">新增用户</span>
                <span class="info-value">{{item.ADDUSER}}</span>
              </div>
              <div class="info-row">
                <span class="info-label">审核用户</span>
                <span class="info-value">{{item.CHKUSER}}</span>
              </div>
            </div>
            <div class="info-row-wrapper">
              <div class="info-row">
                <span class="info-label">盘点日期</span>
                <span class="info-value">{{item.ICDTTM}}</span>
              </div>
            </div>
            <div class="info-row-wrapper" v-if="item.RMK">
              <div class="info-row info-row-full">
                <span class="info-label">备注</span>
                <span class="info-value">{{item.RMK}}</span>
              </div>
            </div>
          </div>

          <!-- 卡片底部操作按钮 -->
          <div class="card-actions">
            <van-button 
              class="action-btn action-btn-view" 
              size="small"
              @click="handleView(item)"
              :style="{ background: '#235EFF', color: '#FFFFFF', border: 'none' }"
            >
              <span>查看</span>
            </van-button>
            <van-button 
              v-if="item.STFG !== 'Y'"
              class="action-btn action-btn-edit"
              size="small"
              :disabled="editBool"
              @click="handleStart(item)"
              :style="editBool ? { background: '#AAAAAA', color: '#FFFFFF', border: 'none' } : { background: '#1ECD84', color: '#FFFFFF', border: 'none' }"
            >
              <span>开始</span>
            </van-button>
<!--            <van-button-->
<!--                v-if="item.STFG !== 'Y'"-->
<!--                class="action-btn action-btn-confirm"-->
<!--                size="small"-->
<!--                :disabled="editBool"-->
<!--                :style="editBool ? { background: '#AAAAAA', color: '#FFFFFF', border: 'none' } : { background: '#1ECD84', color: '#FFFFFF', border: 'none' }"-->
<!--            >-->
<!--              <span>确认</span>-->
<!--            </van-button>-->
          </div>
        </div>
      </div>
    </div>

    <!-- 新增盘点单据弹窗 -->
    <van-dialog
      v-model="showAddDialog"
      title="新增盘点单据"
      show-cancel-button
      confirm-button-text="保存并开始"
      cancel-button-text="取消"
      :before-close="beforeAddClose"
      class-name="add-check-dialog"
    >
      <div style="padding: 12px 16px;">
        <van-cell-group :border="false">
          <van-field
            v-model="addForm.ICDTTM"
            label="盘点日期"
            required
            readonly
            placeholder="请选择盘点日期"
            @click="showDatePicker = true"
          />
          <van-field
            v-model="addForm.STKNM"
            label="盘点仓库"
            required
            readonly
            placeholder="请选择盘点仓库"
            @click="showWarehousePicker = true"
          />
          <van-field
            v-model="addForm.OTHTYNM"
            label="盘点类型"
            required
            readonly
            placeholder="请选择盘点类型"
            @click="showCheckTypePicker = true"
          />
          <van-field
            v-model="addForm.ADDUSER"
            label="新增用户"
            readonly
            disabled
          />
          <van-field
            v-model="addForm.RMK"
            label="备注"
            placeholder="请输入备注"
            type="textarea"
            rows="2"
            autosize
          />
        </van-cell-group>
      </div>
    </van-dialog>

    <!-- 日期选择器 -->
    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择盘点日期"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>

    <!-- 仓库选择器 -->
    <van-popup v-model="showWarehousePicker" position="bottom">
      <van-picker
        title="选择盘点仓库"
        show-toolbar
        :columns="warehouseColumns"
        @confirm="onWarehouseConfirm"
        @cancel="showWarehousePicker = false"
      />
    </van-popup>

    <!-- 盘点类型选择器 -->
    <van-popup v-model="showCheckTypePicker" position="bottom">
      <van-picker
        title="选择盘点类型"
        show-toolbar
        :columns="checkTypeColumns"
        @confirm="onCheckTypeConfirm"
        @cancel="showCheckTypePicker = false"
      />
    </van-popup>

  </div>
</template>

<script>
import {getDate,getDate2,formateDay} from '@/api/tools'
import {getBaseData,getTabColOrData} from '@/api/user';
export default {
  name: "stock_check",
  data() {
    return {
      v_confirm:false,
      v_commit:false,
      v_select:false,
      imgData:[],
      v_formRow:{},
      ordArr:[],
      v_ordWin:false,
      v_search:'',
      v_cond:'',
      phoData:[],
      editWin:false,
      currentPage: 1,
      scroll: 0,
      topShow: false,
      v_username :this.$cookies.get('v_telno' ), //用户名称
      v_corpid:this.$cookies.get('v_corpid' ),
      v_usernm :this.$cookies.get('v_usernm' ), //用户名称
      v_title:'',
      v_flag:'N',
      dtlData:[],
      txtparam:'',
      addBool:false,
      editBool:false,
      selWin:false,
      tabData:[],
      tabCol:[],
      allData:[],
      v_total:0,
      rowSize:20,
      delBool:false,
      mainRow:{},
      showCalendar:false,
      v_key:'',
      v_row:{},
      v_index:'',
      badArr:[],
      v_idseq:this.$cookies.get('idseq'),
      comboArr:{},
      listLoading:false,
      // 新增盘点单据相关
      showAddDialog: false,
      showDatePicker: false,
      showWarehousePicker: false,
      showCheckTypePicker: false,
      currentDate: new Date(),
      minDate: new Date(2024, 1, 1),
      maxDate: new Date(2030, 11, 31),
      warehouseColumns: [],
      checkTypeColumns: [],
      addForm: {
        ICDTTM: '',
        STKNO: '',
        STKNM: '',
        OTHTY: '',
        OTHTYNM: '',
        RMK: '',
        ADDUSER: '',
        ADDDTTM: '',
        IDTY: 'CHECK',
        STFG: 'N',
        CORPID: ''
      }
    }
  },
  components: {

  },
  mounted() {
    //窗口滚动
    window.addEventListener("scroll", this.windowScroll)
    if (this.$cookies.get('v_telno' )){
      this.getTabList(" and STFG != 'Y' and ICDTTM >= '" + getDate2(30) + "'")
      this.initData() //初始化一些数据
    }else{
      this.$router.push({path:'/login'})
    }
  },
  methods: {
    // 查看详情
    handleView(item) {
      this.$router.push({
        path: '/stockCheck/check',
        query: {
          IDSEQ: item.IDSEQ,
          IDNO: item.IDNO,
          STKNO: item.STKNO,
          STKNM: item.STKNM,
          OTHTY: item.OTHTY,
          OTHTYNM: item.OTHTYNM,
          ICDTTM: item.ICDTTM,
          ADDUSER: item.ADDUSER,
          ADDDTTM: item.ADDDTTM,
          RMK: item.RMK,
          STFG: item.STFG,
          mode: 'view'
        }
      })
    },
    // 开始盘点 (未审核单据进入盘点)
    handleStart(item) {
      this.$router.push({
        path: '/stockCheck/check',
        query: {
          IDSEQ: item.IDSEQ,
          IDNO: item.IDNO,
          STKNO: item.STKNO,
          STKNM: item.STKNM,
          OTHTY: item.OTHTY,
          OTHTYNM: item.OTHTYNM,
          ICDTTM: item.ICDTTM,
          ADDUSER: item.ADDUSER,
          ADDDTTM: item.ADDDTTM,
          RMK: item.RMK,
          STFG: item.STFG,
          mode: 'check'
        }
      })
    },
    // 兼容原有的编辑盘点
    handleEdit(item) {
      this.handleStart(item)
    },

    onSearch(){
      let v_cond=" and STFG != 'Y' and ICDTTM >= '" + getDate2(30) + "' and (idno like '%"+this.v_search+"%' or adduser like '%"+this.v_search+"%' )"
      this.getTabList(v_cond)
    },
    //获取权限
    getPriv(){
      this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: { p_table:'v_sys_user_priv' ,p_key:'frmidseq',p_value:'419824' ,p_key2:'userno',p_value2: this.v_username},
      }).then(res=>{
        let row =res.result[0]
        if (row.ISADD==='N'){ //新增
          this.addBool=true
        }if (row.ISUPD==='N'){ //修改
          this.editBool=true
        }if (row.ISDEL==='N'){ //删除
          this.delBool=true
        }
      })
    },
    //页面导航
    changePage(index){
      var _start = ( index - 1 ) * this.rowSize;
      var _end = index * this.rowSize;
      this.tabData = this.allData.slice(_start,_end);
    },
    //返回
    onClickLeft(){
      this.$router.push({
        path: '/features' ,//url指的是跳转的路径名，需要在router里面配置
      })
    },
    initData(){
      this.$axios({  //p_key:'idseq',p_value:v_seq,
        method: 'post',
        url:  'xuper_auth/getBaseData',
        data: {p_key:'isqry',p_value:'M',p_key2:'frmurl' ,p_value2:this.$route.query.path,p_table:'V_Sys_form' },
      }).then(res=>{
        if (res.result.length>0){
          this.v_title =res.result[0]['CFRMNM']

        }else{
          this.$dialog.alert({ title: '提示', message: '没有找到记录'+ res.result, theme: 'round-button',})
        }
      })
      this.getPriv()
      // 初始化订单
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: { p_table:'v_sys_base' , p_cond:' and parentno=\'467733\'  '},
      }).then(res=>{
        this.badArr =res.result
      })
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: { p_table:'V_ORDITM_H5' ,p_key:'corpid',p_value:this.v_corpid ,p_cond:' and rownum<30  '},
      }).then(res=>{
        this.ordArr =res.result
      })
    },
    //明细查询
    getTabList(cond_) {
      this.tabData = []
      this.listLoading = true
      this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {p_table:'v_IC_STK' ,p_cond:cond_ +' order by adddttm desc',p_key:'corpid',p_value:this.v_corpid, p_key2: 'IDTY', p_value2: 'CHECK',},
      }).then(res=>{
        if (res.code=='200'){
          this.allData = res.result
          this.initPage()
        }else{
          this.$notify({ type: 'warning', message: res.result})
        }
      }).finally(() => { this.listLoading = false })
    },
    initPage(){
      this.v_total = this.allData.length //总条数
      this.tabData = this.allData
    },
    windowScroll() {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      this.scroll > 300 ? (this.topShow = true) : (this.topShow = false);
    },

    onAdd() {
      if (this.addBool) {
        return
      }
      // 初始化新增表单
      this.addForm = {
        ICDTTM: formateDay(new Date()),
        STKNO: '',
        STKNM: '',
        OTHTY: '',
        OTHTYNM: '',
        RMK: '',
        ADDUSER: this.v_usernm,
        ADDDTTM: getDate('day'),
        IDTY: 'CHECK',
        STFG: 'N',
        CORPID: this.v_corpid
      }
      this.currentDate = new Date()
      this.loadComboData()
      this.showAddDialog = true
    },
    // 加载下拉框数据
    loadComboData() {
      if (this.warehouseColumns.length > 0 && this.checkTypeColumns.length > 0) {
        return
      }
      this.$axios({
        method: 'post',
        url: 'xuper_auth/getBaseData',
        data: {
          p_table: 'v_sys_form_fld',
          p_key: 'idseq',
          p_value: '96',
          p_cond: ' and lstseq in (1,2)',
          p_key2: 'edcss',
          p_value2: 'select'
        }
      }).then(res => {
        if (res.result && res.result.length > 0) {
          for (let k = 0; k < res.result.length; k++) {
            getBaseData(
              'xuper_auth/getBaseData',
              'parentno',
              res.result[k].COMBO,
              '',
              '',
              'v_sys_base',
              ''
            ).then(res2 => {
              if (res.result[k].FLDNO === 'STKNO') {
                this.warehouseColumns = (res2.result || []).map(item => ({
                  text: item.CNAME,
                  value: item.IDSEQ
                }))
              }
              if (res.result[k].FLDNO === 'OTHTY') {
                this.checkTypeColumns = (res2.result || []).map(item => ({
                  text: item.CNAME,
                  value: item.IDSEQ
                }))
              }
            })
          }
        }
      })
    },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    onDateConfirm(value) {
      this.addForm.ICDTTM = this.formatDate(value)
      this.showDatePicker = false
    },
    onWarehouseConfirm(value) {
      this.addForm.STKNM = value.text
      this.addForm.STKNO = value.value
      this.showWarehousePicker = false
    },
    onCheckTypeConfirm(value) {
      this.addForm.OTHTYNM = value.text
      this.addForm.OTHTY = value.value
      this.showCheckTypePicker = false
    },
    // 新增弹窗关闭拦截与保存
    beforeAddClose(action, done) {
      if (action === 'cancel') {
        done()
        return
      }
      if (action === 'confirm') {
        if (!this.addForm.ICDTTM) {
          this.$toast('盘点日期不能为空')
          done(false)
          return
        }
        if (!this.addForm.STKNO) {
          this.$toast('盘点仓库不能为空')
          done(false)
          return
        }
        if (!this.addForm.OTHTY) {
          this.$toast('盘点类型不能为空')
          done(false)
          return
        }

        const toast = this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '正在创建单据...'
        })

        this.$axios({
          method: 'post',
          url: 'xuper_auth/formOneSave',
          data: {
            p_json: JSON.stringify(Object.assign({}, this.addForm, { CORPID: this.v_corpid })),
            p_table: 'IC_STK',
            frmid: '96'
          }
        }).then(res => {
          toast.clear()
          if (res.code === '200') {
            const newIdseq = res.idseq
            const newIdno = res.idno || res.IDNO || ''
            this.$toast.success('单据创建成功')
            done()
            // 自动跳转到盘点操作页面
            this.$router.push({
              path: '/stockCheck/check',
              query: {
                IDSEQ: newIdseq,
                IDNO: newIdno,
                STKNO: this.addForm.STKNO,
                STKNM: this.addForm.STKNM,
                OTHTY: this.addForm.OTHTY,
                OTHTYNM: this.addForm.OTHTYNM,
                ICDTTM: this.addForm.ICDTTM,
                ADDUSER: this.addForm.ADDUSER,
                ADDDTTM: this.addForm.ADDDTTM,
                RMK: this.addForm.RMK,
                STFG: 'N',
                mode: 'check'
              }
            })
          } else {
            this.$toast.fail(res.result || '单据创建失败')
            done(false)
          }
        }).catch(err => {
          toast.clear()
          console.error('单据创建失败', err)
          this.$toast.fail('创建失败，请重试')
          done(false)
        })
      }
    }
  },

};
</script>
<style lang="scss" scoped>
.stock-list-loading {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,.82);
}
// 盘点卡片样式
.check-card {
  background: #FFFFFF;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 10px;
  border-bottom: 1px solid #F0F0F0;
  
  .card-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: #333333;
    flex: 1;
  }
  
  .card-status {
    font-size: 12px;
    line-height: 20px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 500;
    
    &.status-success {
      background: rgba(30, 205, 132, 0.1);
      color: #1ECD84;
    }
    
    &.status-processing {
      background: rgba(35, 94, 255, 0.1);
      color: #235EFF;
    }
    
    &.status-pending {
      background: rgba(253, 199, 28, 0.1);
      color: #FDC71C;
    }
    
    &.status-cancel {
      background: rgba(170, 170, 170, 0.1);
      color: #AAAAAA;
    }
    
    &.status-default {
      background: rgba(102, 102, 102, 0.1);
      color: #666666;
    }
  }
}

.card-content {
  padding: 4px 12px;
  
  .info-row-wrapper {
    display: flex;
    gap: 12px;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .info-row {
    display: flex;
    flex: 1;
    min-width: 0;
    font-size: 14px;
    line-height: 22px;
    
    &.info-row-full {
      flex: 1 1 100%;
    }
    
    .info-label {
      color: #666666;
      font-size: 14px;
      min-width: 70px;
      flex-shrink: 0;
    }
    
    .info-value {
      color: #333333;
      font-size: 14px;
      flex: 1;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 4px;
  border-top: 1px solid #F0F0F0;
  
  .action-btn {
    height: 26px;
    padding: 0 12px;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    transition: all 0.3s;
    
    i {
      font-size: 12px;
    }
    
    &.action-btn-view {
      background: #235EFF !important;
      color: #FFFFFF !important;
      
      &:active {
        background: #103B9A !important;
      }
    }
    
    &.action-btn-edit {
      background: #FDC71C !important;
      color: #333333 !important;
      
      &:active {
        background: #FBA703 !important;
      }
      
      &.van-button--disabled {
        background: #AAAAAA !important;
        color: #FFFFFF !important;
        opacity: 0.6;
      }
    }
    
    &.action-btn-confirm {
      background: #1ECD84 !important;
      color: #FFFFFF !important;
      
      &:active {
        background: #12A66A !important;
      }
      
      &.van-button--disabled {
        background: #AAAAAA !important;
        opacity: 0.6;
      }
    }
    
    &.action-btn-delete {
      background: #FF4000 !important;
      color: #FFFFFF !important;
      
      &:active {
        background: #CC3300 !important;
      }
      
      &.van-button--disabled {
        background: #AAAAAA !important;
        opacity: 0.6;
      }
    }
  }
}

.go_top_btn {
  width: 50px;
  height: 50px;
  line-height: 50px;
  padding-top: 6px;
  background-color: #FFFFFF;
  border-radius: 50%;
  border: 1px solid #DCDCDC;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: fixed;
  right: 20px;
  bottom: 80px;
  cursor: pointer;
  z-index: 99;
  * {
    cursor: pointer;
  }
}

.div_gray {
  color: #AAAAAA !important;
}

.div_primary {
  color: #235EFF !important;
}

.mul-div {
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.div_ellip {
  text-align: left;
  width: calc(100% - 70px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.rounded-corner {
  border-radius: 8px;
  background-color: #FFFFFF;
  padding: 16px;
  margin: 8px;
  min-height: 165px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.div-corner {
  border-radius: 8px;
  background-color: #FFFFFF;
  padding: 12px;
  margin: 8px;
  min-height: 95px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.imgcss {
  width: 100%;
  height: 100px;
  margin-left: 5px;
  margin-right: 5px;
}

.face {
  position: relative;
  .upload {
    width: calc(100% - 10px);
    height: 48px;
    line-height: 48px;
    opacity: 0;
    position: absolute;
    z-index: 22;
    left: 0;
    margin: auto;
    right: 0;
  }
  .span-txt {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    margin: auto;
    right: 0;
    background: #235EFF;
    width: calc(100% - 10px);
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    text-align: center;
    transition: all 0.3s;

    &:active {
      background: #103B9A;
    }
  }
}

.scan {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  .scan-box {
    width: 100%;
  }
  .close-scan {
    position: absolute;
    top: 20px;
    right: 20px;
    svg {
      width: 40px;
      height: 40px;
    }
  }
}

.one-div {
  display: flex;
  align-items: center;
  padding: 12px 8px;
  background: #F7F8FA;
  margin-top: 8px;

  .oneRow {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: #333333;
  }
}

::v-deep .van-search {
  padding: 0;

  .van-search__content {
    background: #FFFFFF;
    border-radius: 15px;
    border: 1px solid #E5E5E5;
    height: 30px;
    padding-left: 8px;

    &--round {
      border-radius: 15px;
    }
  }

  .van-field__left-icon {
    margin-right: 4px;
  }

  input {
    font-size: 13px;
    line-height: 30px;
    color: #333333;
    height: 30px;

    &::placeholder {
      color: #999999;
      font-size: 13px;
    }
  }
}

.icon-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 26px;
    color: #333333;
  }
}

.info-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;

  .info-row {
    display: flex;
    margin-bottom: 12px;
    flex-wrap: nowrap;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .info-item {
    flex: 1;
    display: flex;
    font-size: 13px;
    line-height: 22px;
    min-width: 0;

    &.full-width {
      flex: 1 1 100%;
    }

    .info-label {
      color: #333333;
      font-weight: 500;
      min-width: 80px;
      flex-shrink: 0;
      white-space: nowrap;
    }

    .info-value {
      color: #666666;
      flex: 1;
      word-wrap: break-word;
      word-break: break-all;
    }
  }
}

.form-item {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  .form-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .form-label {
      color: #333333;
      font-size: 13px;
      font-weight: 500;
      min-width: 90px;
      flex-shrink: 0;

      .required {
        color: #FF4000;
        margin-right: 2px;
      }
    }

    input, select {
      flex: 1;
      height: 32px;
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      padding: 0 8px;
      font-size: 13px;
      color: #333333;

      &:focus {
        border-color: #235EFF;
        outline: none;
      }
    }
  }
}

.upload-btn-wrapper {
  position: relative;
  margin-bottom: 16px;

  .upload-input {
    width: 100%;
    height: 48px;
    opacity: 0;
    position: absolute;
    z-index: 2;
    cursor: pointer;
  }

  .upload-btn {
    width: 100%;
    height: 48px;
    background: #235EFF;
    color: #FFFFFF;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;

    &:active {
      background: #103B9A;
    }
  }
}

.image-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-top: 12px;

  .image-item {
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;

    .image-preview {
      width: 100%;
      height: 120px;
      display: block;
      border-radius: 8px 8px 0 0;
    }

    .image-delete-wrapper {
      padding: 8px;

      .delete-image-btn {
        background: #FF4000;
        color: #FFFFFF;
        border: none;
        height: 32px;
        font-size: 12px;
        border-radius: 6px;

        &:active {
          background: #CC3300;
        }
      }
    }
  }
}

::v-deep .van-text-box {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 12px;
  padding-bottom: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

::v-deep .van-pagination {
  padding: 12px 0;
  background: #FFFFFF;

  .van-pagination__item {
    border-radius: 8px;
    color: #666666;
    font-size: 14px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;

    &--active {
      background: #235EFF;
      color: #FFFFFF;
    }
  }
}

// 强制覆盖 van-button 默认样式
::v-deep .action-btn.van-button {
  border: none !important;
  
  &.action-btn-view {
    background: #235EFF !important;
    
    .van-button__text {
      color: #FFFFFF !important;
    }
  }
  
  &.action-btn-edit {
    background: #FDC71C !important;
    
    .van-button__text {
      color: #333333 !important;
    }
  }
  
  &.action-btn-confirm {
    background: #1ECD84 !important;
    
    .van-button__text {
      color: #FFFFFF !important;
    }
  }
  
  &.action-btn-delete {
    background: #FF4000 !important;
    
    .van-button__text {
      color: #FFFFFF !important;
    }
  }
}

</style>
<style lang="less">
.van-pagination__item {
  border-radius: 8px;
  color: #666666;
}
</style>
